var configurationPost = {
    method: 'post',
    headers: {
      'Accept': 'application/json, text/plain, *.*',
      'Content-Type': 'application/json',
    },
    body: ''
  }
export default configurationPost